import { gql, useQuery } from "@apollo/client";

const shortPublication = `
_id
name
status
websiteId
publisher {
  name
}
website {
  _id
  name
  allowSelfHostedAdvertorials
  cpcFloorPrice
  cprFloorPrice
  floorPriceExemptCompanyIds
}
rateCard {
  click
  lead
  read
  bidMultiplier
}
startDate
startDateOverwritten
endDate
endDateOverwritten
contentOverwritten
landingPage
landingPageOverwritten
`
export const PUBLICATION_QUERY = gql`
query PublicationById($id: ObjectId!) {
  publication: PublicationById(_id: $id) {
    ${shortPublication}
    actions {
      action
      disabled
      disabledReason
    }
    budget
    trackingTag {
      tagType
      tagUrl
    }
    previewUrl
    finalUrl
    content {
      headline
      articleByline
      teaser
      coverImage
      contentObject
      contentImages
    }
    selfHostedContent {
      url
      cmsArticleId
    }
    providerContent {
      providerContentId
    }
  }
}
`
export const CAMPAIGN_PUBLICATIONS_QUERY = gql`
query PublicationMany($page: Int, $perPage: Int, $filters: PublicationFilterArgs) {
  publications: PublicationMany(page: $page, perPage: $perPage, filters: $filters) {
    items {
      ${shortPublication}
    }
    meta {
      totalItems
    }
  }
}
`
const PUBLICATIONS_QUERY = gql`
query PublicationMany($perPage: Int) {
  PublicationMany(perPage: $perPage) {
    items {
      name
      publisher {
        name
        _id
      }
      website {
        _id
        url
        name
      }
      campaignId
      campaign {
        name
      }
    }
  }
}
`;


// TODO: Use PublicationActionType instead of String?
export const RUN_PUBLICATION_ACTION = gql`
  mutation RunPublicationAction(
    $action: String!
    $publicationId: ObjectId!
  ) {
    RunPublicationAction(action: $action, publicationId: $publicationId) {
      _id
      status
      publicationDate
      actions {
        action
        disabled
        disabledReason
      }
    }
  }
`;

type PublicationManyResult = {
  PublicationMany: {
    name: string;
    publisher: {
      name: string;
      _id: string;
    };
    website: {
      _id: string;
      url: string;
      name: string;
    };
    campaignId: string;
    campaign: {
      name: string;
    };
  }[];
};

export function usePublicationMany(variables: any) {
  const { loading, error, data } = useQuery<PublicationManyResult>(
    PUBLICATIONS_QUERY,
    { variables }
  );

  return { loading, error, data };
}
